<template>
	<div class="container">
		<div class="top_title">
			<router-link class="icon_back" :to="{ name: 'H600010' }" tag="span"></router-link>
			<span style="padding-right: 2.4rem">校长回访</span>
		</div>
		<div class="scroll_area" style="overflow-y: auto">
			<div class="weui-cells item" style="border: 0 !important; margin-top: 2.4rem">
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>校区</p>
					</div>
					<div class="weui-cell__ft">
						<select :disabled="true" class="weui-select" v-model="I_SCHOOL_VALUE" style="color: #bbb; width: 10.8rem">
							<option value="">请选择</option>
							<option v-for="(item, index) in SCHOOL_LIST" :key="index" :value="item.I_SCHOOL_NO">
								{{ item.I_SCHOOL_NAME }}
							</option>
						</select>
					</div>
				</div>
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>班级</p>
					</div>
					<div class="weui-cell__ft">
						<select :disabled="true" class="weui-select" v-model="I_CLASS_VALUE" @click="onClickClass" style="color: #bbb; width: 10.8rem">
							<option value="">请选择</option>
							<option v-for="(item, index) in CLASS_LIST" :key="index" :value="item.I_CLASS_NO">
								{{ item.I_CLASS_NAME }}
							</option>
						</select>
					</div>
				</div>
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>学员</p>
					</div>
					<div class="weui-cell__ft">
						<select :disabled="true" class="weui-select" v-model="I_STUDENT_VALUE" @click="onClickStudent" style="color: #bbb; width: 10.8rem">
							<option value="">请选择</option>
							<option v-for="(item, index) in STUDENT_LIST" :key="index" :value="item.I_STUDENT_NO">
								{{ item.I_STUDENT_NAME }}
							</option>
						</select>
					</div>
				</div>
				<div class="weui-cell weui-cell_select weui-cell_select-after">
					<div class="weui-cell__bd">
						<p>回访日期</p>
					</div>
					<div class="weui-cell__ft">
						<span class="weui-select" id="showDatePicker" style="color: #bbb;padding-right: 2rem;">
							{{dateValue}}
						</span>
					</div>
				</div>
				<div>
					<el-input style="border: 0; outline: none" :readonly="I_FLAG != 'U'" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }"
					 placeholder="请输入回访备注" v-model="I_REMARK">
					</el-input>
				</div>
			</div>
			<button v-if="I_FLAG == 'U'" class="bottom_btn" @click="commit_ReturnVisit">
				提交
			</button>
		</div>
	</div>
</template>

<script>
	import DataRequestFactory from "@/factories/dataRequestFactory.js";
	import weui from "weui.js";
	export default {
		data() {
			return {
				I_KEY: "",

				textarea: "",
				I_SCHOOL_NAME: "",
				I_SCHOOL_VALUE: "",
				SCHOOL_LIST: [],
				I_CLASS_NAME: "",
				I_CLASS_VALUE: "",
				CLASS_LIST: [],
				I_REMARK: "",
				dateValue: "请选择",
				STUDENT_LIST: [],
				I_STUDENT_NAME: "",
				I_STUDENT_VALUE: "",
				I_FLAG: "",

				pickerOptions: {
					disabledDate(time) {
						let curDate = new Date().getTime();
						let three = 90 * 24 * 3600 * 1000;
						let threeMonths = curDate - three;
						return time.getTime() > Date.now() || time.getTime() < threeMonths;
					},
				},
			};
		},
		created() {
			if (this.$router.options.routes[7].name !== "H000003") {
				location.reload();
			}
			this.I_KEY = this.$route.params.id ?
				this.$route.params.id :
				window.localStorage.getItem("H600010");
		},
		methods: {
			//初始化
			init() {
				let requestParams = {
					I_KEY: this.I_KEY,
				};
				console.log(this.I_KEY);
				let that = this;
				DataRequestFactory.I600020(requestParams).then((response) => {
					console.log(response);
					that.SCHOOL_LIST = response.dataList1;
					for (let i = 0; i < that.SCHOOL_LIST.length; i++) {
						if (that.SCHOOL_LIST[i].I_SELECTED == "Y") {
							that.I_SCHOOL_VALUE = that.SCHOOL_LIST[i].I_SCHOOL_NO;
							that.I_SCHOOL_NAME = that.SCHOOL_LIST[i].I_SCHOOL_NAME;
						}
					}
					that.CLASS_LIST = response.dataList2;
					for (let n = 0; n < that.CLASS_LIST.length; n++) {
						if (that.CLASS_LIST[n].I_SELECTED == "Y") {
							that.I_CLASS_VALUE = that.CLASS_LIST[n].I_CLASS_NO;
							that.I_CLASS_NAME = that.CLASS_LIST[n].I_CLASS_NAME;
						}
					}
					that.STUDENT_LIST = response.dataList3;
					for (let x = 0; x < that.STUDENT_LIST.length; x++) {
						if (that.STUDENT_LIST[x].I_SELECTED == "Y") {
							that.I_STUDENT_VALUE = that.STUDENT_LIST[x].I_STUDENT_NO;
							that.I_STUDENT_NAME = that.STUDENT_LIST[x].I_STUDENT_NAME;
						}
					}
					that.dateValue = response.I_DATE;
					that.I_REMARK = response.I_REMARK;
					that.I_FLAG = response.I_FLAG;
				});
			},
			//时间监听
			onChangeDatePicker(e) {},
			//班级
			onClickClass() {
				// if (this.I_SCHOOL_VALUE == "") {
				// 	weui.topTips('请先选择校区', 1000)
				// 	return;
				// }
				let requestParams = {
					I_SCHOOL_NO: this.I_SCHOOL_VALUE,
				};
				DataRequestFactory.C010011(requestParams).then((response) => {
					console.log(response);
					this.CLASS_LIST = response.dataList;
				});
			},
			//学员
			onClickStudent() {
				// if (this.I_SCHOOL_VALUE == "") {
				// 	weui.topTips('请先选择校区', 1000)
				// 	return;
				// } else if (this.I_CLASS_VALUE == null) {
				// 	weui.topTips('请先选择班级', 1000)
				// 	return;
				// }
				let requestParams = {
					I_SCHOOL_NO: this.I_SCHOOL_VALUE,
					I_CLASS_NO: this.I_CLASS_VALUE,
				};
				DataRequestFactory.C010012(requestParams).then((response) => {
					console.log(response);
					this.STUDENT_LIST = response.dataList;
				});
			},
			//提交回访记录
			commit_ReturnVisit() {
				// if (this.I_SCHOOL_VALUE == "") {
				// 	weui.topTips('请先选择校区', 1000)
				// 	return;
				// } else if (this.I_CLASS_VALUE == "") {
				// 	weui.topTips('请先选择班级', 1000)
				// 	return;
				// } else if (this.I_STUDENT_VALUE == "") {
				// 	weui.topTips('请先选择学员', 1000)
				// 	return
				// } else if (this.dateValue == "") {
				// 	weui.topTips('请选择回访日期', 1000)
				// 	return
				// } else if (this.I_REMARK == "") {
				// 	console.log(this.I_REMARK.length, this.I_REMARK)
				// 	weui.topTips('请输入回访内容', 1000)
				// 	return
				// }
				let requestParams = {
					I_SCHOOL_NO: this.I_SCHOOL_VALUE,
					I_CLASS_NO: this.I_CLASS_VALUE,
					I_STUDENT_NO: this.I_STUDENT_VALUE,
					I_DATE: this.dateValue,
					I_REMARK: this.I_REMARK,
				};
				DataRequestFactory.I600021(requestParams).then((response) => {
					console.log(response);
					if (response.resultCode == 0) {
						weui.toast("提交成功", 2000);
					}
					this.$router.push("/H600010");
				});
			},
			// 设置日期 20210302 xyf
			// showDatePicker() {
			// 	let year = new Date().getFullYear()
			// 	let month = new Date().getMonth() + 1
			// 	let day = new Date().getDate()
			// 	let that = this
			// 	weui.datePicker({
			// 		// start: 1990,
			// 		start: new Date().getFullYear() - 1,
			// 		end: new Date().getFullYear(),
			// 		defaultValue: [year, month, day],
			// 		// onChange: function (result) {
			// 		//     console.log(result);
			// 		// },
			// 		onConfirm: function(result) {
			// 			that.dateValue = result[0].value + "-" + result[1].value + "-" + result[2].value
			// 		}
			// 	});
			// }
		},
		mounted() {
			var win_h = $(window).height(); //关键代码
			$("body").height(win_h); //关键代码
			this.init();
		},
	};
</script>

<style scoped>
	.el-textarea__inner {
		border: 0;
		outline: none;
		padding: 0.8rem;
		width: 100%;
		height: 8rem;
		box-sizing: border-box;
	}
</style>



// WEBPACK FOOTER //
// src/pages/H000003.vue